var L = Object.defineProperty;
var N = (t, e, n) => e in t ? L(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n;
var l = (t, e, n) => N(t, typeof e != "symbol" ? e + "" : e, n);
import { jsx as u, jsxs as $ } from "react/jsx-runtime";
import { createContext as U, useContext as b, useEffect as w, useState as S, useMemo as q } from "react";
var J = { palette: { icon: { error: "var(--palette-icon-error)" } } }, g;
(function(t) {
  t.RCL = "R", t.CEL = "C";
})(g || (g = {}));
function V({ brand: t, size: e, fill: n, filled: r, ...o }) {
  const i = u("svg", { role: "icon", "data-testid": "eye-rcl-stroke", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, viewBox: "0 0 16 16", fill: "none", ...o, children: u("path", { d: "M8 6.45455C8.43399 6.45455 8.85021 6.62695 9.15708 6.93383C9.46396 7.2407 9.63636 7.65692 9.63636 8.09091C9.63636 8.5249 9.46396 8.94112 9.15708 9.24799C8.85021 9.55487 8.43399 9.72727 8 9.72727C7.56601 9.72727 7.14979 9.55487 6.84292 9.24799C6.53604 8.94112 6.36364 8.5249 6.36364 8.09091C6.36364 7.65692 6.53604 7.2407 6.84292 6.93383C7.14979 6.62695 7.56601 6.45455 8 6.45455ZM8 4C10.7273 4 13.0564 5.69636 14 8.09091C13.0564 10.4855 10.7273 12.1818 8 12.1818C5.27273 12.1818 2.94364 10.4855 2 8.09091C2.94364 5.69636 5.27273 4 8 4ZM3.18909 8.09091C3.62996 8.99108 4.31453 9.7495 5.16499 10.28C6.01545 10.8104 6.99767 11.0916 8 11.0916C9.00233 11.0916 9.98455 10.8104 10.835 10.28C11.6855 9.7495 12.37 8.99108 12.8109 8.09091C12.37 7.19074 11.6855 6.43232 10.835 5.90186C9.98455 5.3714 9.00233 5.09019 8 5.09019C6.99767 5.09019 6.01545 5.3714 5.16499 5.90186C4.31453 6.43232 3.62996 7.19074 3.18909 8.09091Z", fill: n }) }), s = u("svg", { role: "icon", "data-testid": "eye-cel-stroke", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, viewBox: "0 0 16 16", fill: "none", ...o, children: u("path", { d: "M8 6.45455C8.43399 6.45455 8.85021 6.62695 9.15708 6.93383C9.46396 7.2407 9.63636 7.65692 9.63636 8.09091C9.63636 8.5249 9.46396 8.94112 9.15708 9.24799C8.85021 9.55487 8.43399 9.72727 8 9.72727C7.56601 9.72727 7.14979 9.55487 6.84292 9.24799C6.53604 8.94112 6.36364 8.5249 6.36364 8.09091C6.36364 7.65692 6.53604 7.2407 6.84292 6.93383C7.14979 6.62695 7.56601 6.45455 8 6.45455ZM8 4C10.7273 4 13.0564 5.69636 14 8.09091C13.0564 10.4855 10.7273 12.1818 8 12.1818C5.27273 12.1818 2.94364 10.4855 2 8.09091C2.94364 5.69636 5.27273 4 8 4ZM3.18909 8.09091C3.62996 8.99108 4.31453 9.7495 5.16499 10.28C6.01545 10.8104 6.99767 11.0916 8 11.0916C9.00233 11.0916 9.98455 10.8104 10.835 10.28C11.6855 9.7495 12.37 8.99108 12.8109 8.09091C12.37 7.19074 11.6855 6.43232 10.835 5.90186C9.98455 5.3714 9.00233 5.09019 8 5.09019C6.99767 5.09019 6.01545 5.3714 5.16499 5.90186C4.31453 6.43232 3.62996 7.19074 3.18909 8.09091Z", fill: n }) });
  return t === g.CEL ? s : i;
}
const G = g.RCL, D = U({
  brand: G,
  urgencyFlags: {}
}), K = () => b(D), _ = "http://localhost".replace(/\/+$/, "");
class T {
  constructor(e = {}) {
    this.configuration = e;
  }
  set config(e) {
    this.configuration = e;
  }
  get basePath() {
    return this.configuration.basePath != null ? this.configuration.basePath : _;
  }
  get fetchApi() {
    return this.configuration.fetchApi;
  }
  get middleware() {
    return this.configuration.middleware || [];
  }
  get queryParamsStringify() {
    return this.configuration.queryParamsStringify || E;
  }
  get username() {
    return this.configuration.username;
  }
  get password() {
    return this.configuration.password;
  }
  get apiKey() {
    const e = this.configuration.apiKey;
    if (e)
      return typeof e == "function" ? e : () => e;
  }
  get accessToken() {
    const e = this.configuration.accessToken;
    if (e)
      return typeof e == "function" ? e : async () => e;
  }
  get headers() {
    return this.configuration.headers;
  }
  get credentials() {
    return this.configuration.credentials;
  }
}
const B = new T(), p = class p {
  constructor(e = B) {
    l(this, "middleware");
    l(this, "fetchApi", async (e, n) => {
      let r = { url: e, init: n };
      for (const i of this.middleware)
        i.pre && (r = await i.pre({
          fetch: this.fetchApi,
          ...r
        }) || r);
      let o;
      try {
        o = await (this.configuration.fetchApi || fetch)(r.url, r.init);
      } catch (i) {
        for (const s of this.middleware)
          s.onError && (o = await s.onError({
            fetch: this.fetchApi,
            url: r.url,
            init: r.init,
            error: i,
            response: o ? o.clone() : void 0
          }) || o);
        if (o === void 0)
          throw i instanceof Error ? new W(i, "The request failed and the interceptors did not return an alternative response") : i;
      }
      for (const i of this.middleware)
        i.post && (o = await i.post({
          fetch: this.fetchApi,
          url: r.url,
          init: r.init,
          response: o.clone()
        }) || o);
      return o;
    });
    this.configuration = e, this.middleware = e.middleware;
  }
  withMiddleware(...e) {
    const n = this.clone();
    return n.middleware = n.middleware.concat(...e), n;
  }
  withPreMiddleware(...e) {
    const n = e.map((r) => ({ pre: r }));
    return this.withMiddleware(...n);
  }
  withPostMiddleware(...e) {
    const n = e.map((r) => ({ post: r }));
    return this.withMiddleware(...n);
  }
  /**
   * Check if the given MIME is a JSON MIME.
   * JSON MIME examples:
   *   application/json
   *   application/json; charset=UTF8
   *   APPLICATION/JSON
   *   application/vnd.company+json
   * @param mime - MIME (Multipurpose Internet Mail Extensions)
   * @return True if the given MIME is JSON, false otherwise.
   */
  isJsonMime(e) {
    return e ? p.jsonRegex.test(e) : !1;
  }
  async request(e, n) {
    const { url: r, init: o } = await this.createFetchParams(e, n), i = await this.fetchApi(r, o);
    if (i && i.status >= 200 && i.status < 300)
      return i;
    throw new k(i, "Response returned an error code");
  }
  async createFetchParams(e, n) {
    let r = this.configuration.basePath + e.path;
    e.query !== void 0 && Object.keys(e.query).length !== 0 && (r += "?" + this.configuration.queryParamsStringify(e.query));
    const o = Object.assign({}, this.configuration.headers, e.headers);
    Object.keys(o).forEach((y) => o[y] === void 0 ? delete o[y] : {});
    const i = typeof n == "function" ? n : async () => n, s = {
      method: e.method,
      headers: o,
      body: e.body,
      credentials: this.configuration.credentials
    }, a = {
      ...s,
      ...await i({
        init: s,
        context: e
      })
    };
    let d;
    j(a.body) || a.body instanceof URLSearchParams || Z(a.body) ? d = a.body : this.isJsonMime(o["Content-Type"]) ? d = JSON.stringify(a.body) : d = a.body;
    const f = {
      ...a,
      body: d
    };
    return { url: r, init: f };
  }
  /**
   * Create a shallow clone of `this` by constructing a new instance
   * and then shallow cloning data members.
   */
  clone() {
    const e = this.constructor, n = new e(this.configuration);
    return n.middleware = this.middleware.slice(), n;
  }
};
l(p, "jsonRegex", new RegExp("^(:?application/json|[^;/ 	]+/[^;/ 	]+[+]json)[ 	]*(:?;.*)?$", "i"));
let h = p;
function Z(t) {
  return typeof Blob < "u" && t instanceof Blob;
}
function j(t) {
  return typeof FormData < "u" && t instanceof FormData;
}
class k extends Error {
  constructor(n, r) {
    super(r);
    l(this, "name", "ResponseError");
    this.response = n;
  }
}
class W extends Error {
  constructor(n, r) {
    super(r);
    l(this, "name", "FetchError");
    this.cause = n;
  }
}
class z extends Error {
  constructor(n, r) {
    super(r);
    l(this, "name", "RequiredError");
    this.field = n;
  }
}
function E(t, e = "") {
  return Object.keys(t).map((n) => M(n, t[n], e)).filter((n) => n.length > 0).join("&");
}
function M(t, e, n = "") {
  const r = n + (n.length ? `[${t}]` : t);
  if (e instanceof Array) {
    const o = e.map((i) => encodeURIComponent(String(i))).join(`&${encodeURIComponent(r)}=`);
    return `${encodeURIComponent(r)}=${o}`;
  }
  if (e instanceof Set) {
    const o = Array.from(e);
    return M(t, o, n);
  }
  return e instanceof Date ? `${encodeURIComponent(r)}=${encodeURIComponent(e.toISOString())}` : e instanceof Object ? E(e, r) : `${encodeURIComponent(r)}=${encodeURIComponent(String(e))}`;
}
class x {
  constructor(e, n = (r) => r) {
    this.raw = e, this.transformer = n;
  }
  async value() {
    return this.transformer(await this.raw.json());
  }
}
function H(t) {
  return Y(t);
}
function Y(t, e) {
  return t == null ? t : {
    itineraryGroupId: t.itineraryGroupId,
    departureDate: t.departureDate == null ? void 0 : new Date(t.departureDate),
    superCategory: t.superCategory == null ? void 0 : t.superCategory
  };
}
function Q(t) {
  return X(t, !1);
}
function X(t, e = !1) {
  return t == null ? t : {
    itineraryGroupId: t.itineraryGroupId,
    departureDate: t.departureDate == null ? void 0 : t.departureDate.toISOString().substring(0, 10),
    superCategory: t.superCategory
  };
}
function ee(t) {
  return te(t);
}
function te(t, e) {
  return t == null ? t : {
    type: t.type,
    frequency: t.frequency,
    rank: t.rank,
    count: t.count
  };
}
const ne = {
  Watch: "watch"
};
function re(t) {
  return ie(t, !1);
}
function ie(t, e = !1) {
  return t == null ? t : {
    id: Q(t.id)
  };
}
function oe(t) {
  return se(t, !1);
}
function se(t, e = !1) {
  return t == null ? t : {
    items: t.items.map(re)
  };
}
function ce(t) {
  return ae(t);
}
function ae(t, e) {
  return t == null ? t : {
    id: H(t.id),
    flags: t.flags.map(ee)
  };
}
class ue extends h {
  /**
   */
  async apiV1LocalesIdDictionaryGetRaw(e, n) {
    if (e.id == null)
      throw new z(
        "id",
        'Required parameter "id" was null or undefined when calling apiV1LocalesIdDictionaryGet().'
      );
    const r = {}, o = {}, i = await this.request({
      path: "/api/v1/locales/{id}/dictionary".replace("{id}", encodeURIComponent(String(e.id))),
      method: "GET",
      headers: o,
      query: r
    }, n);
    return new x(i);
  }
  /**
   */
  async apiV1LocalesIdDictionaryGet(e, n) {
    return await (await this.apiV1LocalesIdDictionaryGetRaw(e, n)).value();
  }
}
class de extends h {
  /**
   */
  async apiV1UrgencyPostRaw(e, n) {
    const r = {}, o = {};
    o["Content-Type"] = "application/json", e.xRequestId != null && (o["x-request-id"] = String(e.xRequestId)), e.xCountry != null && (o["x-country"] = String(e.xCountry));
    const i = await this.request({
      path: "/api/v1/urgency",
      method: "POST",
      headers: o,
      query: r,
      body: oe(e.urgencyRequest)
    }, n);
    return new x(i, (s) => s.map(ce));
  }
  /**
   */
  async apiV1UrgencyPost(e = {}, n) {
    return await (await this.apiV1UrgencyPostRaw(e, n)).value();
  }
}
const P = U({
  l: () => "",
  locale: ""
});
function le() {
  return b(P);
}
const I = {
  1: "urgency.frequency.day"
  //7: 'urgency.frequency.week',
  //30: 'urgency.frequency.month',
  //365: 'urgency.frequency.year',
}, fe = (t) => t in I ? I[t] : "urgency.frequency.days", ye = (t) => {
  const { l: e } = le();
  if (!t || t.count <= 0)
    return null;
  const n = (i) => i > 1e3 ? e("urgency.peopleCount.greaterThan1000", { count: Math.ceil(i / 1e3) }) : e("urgency.peopleCount.lessThan1000", { count: i }), r = (i) => {
    const s = {
      peopleCount: n(i.count)
    };
    if (i.type !== ne.Watch) {
      const a = fe(i.frequency);
      s.frequency = e(a, { number: i.frequency });
    }
    return s;
  };
  return ((i) => {
    const s = `urgency.message.${i.type.toLowerCase()}`, a = r(i);
    try {
      return e(s, a);
    } catch {
      return console.error(`Unknown urgency flag type: ${i.type}`), "";
    }
  })(t);
};
var ge = "_579lby0", he = "_579lby1";
const Ne = ({ itineraryId: t, onLoad: e, testId: n }) => {
  const { brand: r, urgencyFlags: o } = K(), i = o[t], s = ye(i);
  return w(() => {
    e && e(i, s);
  }, [e, i, s]), s ? /* @__PURE__ */ $("div", { className: ge, "data-testid": n, children: [
    /* @__PURE__ */ u(V, { fill: J.palette.icon.error, brand: r, size: 16 }),
    /* @__PURE__ */ u("p", { className: he, children: s })
  ] }) : null;
}, c = [];
for (let t = 0; t < 256; ++t)
  c.push((t + 256).toString(16).slice(1));
function pe(t, e = 0) {
  return (c[t[e + 0]] + c[t[e + 1]] + c[t[e + 2]] + c[t[e + 3]] + "-" + c[t[e + 4]] + c[t[e + 5]] + "-" + c[t[e + 6]] + c[t[e + 7]] + "-" + c[t[e + 8]] + c[t[e + 9]] + "-" + c[t[e + 10]] + c[t[e + 11]] + c[t[e + 12]] + c[t[e + 13]] + c[t[e + 14]] + c[t[e + 15]]).toLowerCase();
}
let m;
const me = new Uint8Array(16);
function we() {
  if (!m) {
    if (typeof crypto > "u" || !crypto.getRandomValues)
      throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    m = crypto.getRandomValues.bind(crypto);
  }
  return m(me);
}
const Ce = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), R = { randomUUID: Ce };
function Ie(t, e, n) {
  var o;
  if (R.randomUUID && !t)
    return R.randomUUID();
  t = t || {};
  const r = t.random ?? ((o = t.rng) == null ? void 0 : o.call(t)) ?? we();
  if (r.length < 16)
    throw new Error("Random bytes length must be >= 16");
  return r[6] = r[6] & 15 | 64, r[8] = r[8] & 63 | 128, pe(r);
}
const Re = 1e4, F = new T({
  basePath: "/pulse",
  fetchApi: fetch,
  middleware: [
    {
      pre: async (t) => {
        const e = new AbortController(), n = setTimeout(() => e.abort(), Re);
        return t.init.signal = e.signal, t.init.signal.addEventListener("abort", () => clearTimeout(n)), t;
      }
    }
  ]
}), Ue = new ue(F), be = new de(F), Se = (t) => ({
  items: t.map((e) => ({ id: { itineraryGroupId: e } }))
}), qe = (t) => t.reduce((e, n) => (e[n.id.itineraryGroupId] = n.flags[0], e), {});
function De(t) {
  const e = new Te();
  return (n, r) => Pe(e, t.dictionary, n, r);
}
class Te {
  constructor() {
    l(this, "cache", /* @__PURE__ */ new Map());
  }
  get(e, n, r) {
    const o = `${e}^${Object.values(n).join("^")}`;
    let i = this.cache.get(o);
    return i != null || (i = r(), this.cache.set(o, i)), i;
  }
}
function Ee(t, e) {
  for (const n in e)
    t = t.replaceAll(`{${n}}`, e[n]);
  return t;
}
function Me(t, e) {
  for (let n = 0; n < 10; n++) {
    const r = t.replace(/l\{(.*?)\}/g, (o, i) => e[i] ?? o);
    if (r === t)
      return r;
    t = r;
  }
  return t;
}
const xe = ["zero", "one", "two", "three", "four", "five", "six", "seven", "eight", "nine", "ten"];
function Pe(t, e, n, r) {
  n = Fe(e, n, r);
  const o = e[n];
  return o ? r ? t.get(n, r, () => Ee(Me(o, e), r)) : o : "";
}
function Fe(t, e, n) {
  if (n && "count" in n && n.count != null && typeof n.count == "number") {
    const r = xe[n.count] ?? "other";
    let o = e + "_" + r;
    if (t[o] == null && !o.endsWith("_other") && (o = e + "_other"), t[o] != null)
      return o;
  }
  return e;
}
function Oe({
  children: t,
  locale: e,
  showRawKeys: n
}) {
  const [r, o] = S({});
  w(() => {
    (async () => {
      var f;
      const a = ((f = e.split("-")) == null ? void 0 : f[0]) ?? "en", d = await Ue.apiV1LocalesIdDictionaryGet({ id: a });
      o(d);
    })();
  }, [e]);
  const i = q(
    () => ({
      l: n ? (s) => s : De({
        dictionary: r
      }),
      locale: e
    }),
    [r, e, n]
  );
  return /* @__PURE__ */ u(P.Provider, { value: i, children: t });
}
const $e = ({
  brand: t,
  locale: e,
  country: n,
  itineraryIds: r,
  children: o
}) => {
  const [i, s] = S({});
  w(() => {
    (async () => {
      const f = r.filter(
        (A) => {
          var C;
          return !((C = Object.keys(i)) != null && C.includes(A));
        }
      );
      if (f.length === 0)
        return;
      const y = Se(f), O = await be.apiV1UrgencyPost({
        xCountry: n,
        xRequestId: `cp-web-${Ie()}`,
        urgencyRequest: y
      }), v = qe(O);
      s({ ...i, ...v });
    })();
  }, [e, n, r]);
  const a = q(
    () => ({
      brand: t,
      urgencyFlags: i
    }),
    [t, i]
  );
  return /* @__PURE__ */ u(D.Provider, { value: a, children: /* @__PURE__ */ u(Oe, { locale: e, children: o }) });
};
export {
  $e as CruisePulseProvider,
  Ne as ItineraryUrgency
};
//# sourceMappingURL=index.es.js.map
